"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDateParam = exports.normalizeDateParams = void 0;
const normalizeDateParams = (args) => {
    let [first, second] = args;
    if (typeof first === 'string') {
        first = new Date(first);
    }
    if (typeof second === 'string') {
        second = new Date(second);
    }
    return [first, second];
};
exports.normalizeDateParams = normalizeDateParams;
const normalizeDateParam = (args) => {
    if (typeof args === 'string') {
        args = new Date(args);
    }
    if (typeof args === 'number') {
        args = new Date(args);
    }
    return args;
};
exports.normalizeDateParam = normalizeDateParam;
